import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex-colum h-100" }
const _hoisted_2 = { class: "d-flex justify-content-between bd-highlight mb-3" }
const _hoisted_3 = {
  class: "align-self-center mb-3",
  style: {"height":"30px"}
}
const _hoisted_4 = {
  class: "input-group align-self-center ms-auto p-2 bd-highlight",
  style: {"width":"25%"}
}
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "table table-bordered table-striped table-sm member-list" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "序号"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "客户ID"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "姓名"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "签单时间"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "操作")
  ])
], -1)
const _hoisted_8 = { id: "member-list" }
const _hoisted_9 = { class: "flex-row flex-align-center" }
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_AddExcelDialog = _resolveComponent("AddExcelDialog")!
  const _component_LoadingDialog = _resolveComponent("LoadingDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.openAddExcelDialog && $setup.openAddExcelDialog(...args)))
          }, "添加")
        ]),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.shop) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shops, (value, idx) => {
              return (_openBlock(), _createElementBlock("option", {
                key: idx,
                value: value.id
              }, _toDisplayString(value.name), 9, _hoisted_5))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.shop]
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("table", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("tbody", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dataList, (value, idx) => {
              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                _createElementVNode("td", null, _toDisplayString(50 * ($setup.nowPage - 1) + idx + 1), 1),
                _createElementVNode("td", null, _toDisplayString(value.customer), 1),
                _createElementVNode("td", null, _toDisplayString(value.profile?.name || "未知"), 1),
                _createElementVNode("td", null, _toDisplayString(value.operateDate), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("img", {
                      class: "button-icon",
                      src: "/assets/ic_edit.png",
                      onClick: ($event: any) => ($setup.openEditExcelDialog(value))
                    }, null, 8, _hoisted_10)
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _createVNode(_component_Pagination, {
          page: $setup.nowPage,
          max: $setup.totalPage/50,
          onLoadPage: $setup.loadExcelList
        }, null, 8, ["page", "max", "onLoadPage"])
      ])
    ]),
    _createVNode(_component_AddExcelDialog, {
      show: _ctx.showAddDialog,
      item: _ctx.editing,
      onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showAddDialog = false)),
      onConfirm: $setup.editExcel
    }, null, 8, ["show", "item", "onConfirm"]),
    _createVNode(_component_LoadingDialog, { show: _ctx.showLoadingDialog }, null, 8, ["show"])
  ], 64))
}